import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/shared/shadcn-ui/select';

import { cn } from '@/utils/helpers';

interface OrderCutoffDaysSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const OrderCutoffDaysSelect = ({
  value: valueProp,
  onChange,
  className,
}: OrderCutoffDaysSelectProps) => {
  const { t } = useTranslation();
  const ordersDaysDeadlines = [
    {
      value: '1',
      label: t('order-cutoff-times.days-in-advance.1'),
    },
    {
      value: '2',
      label: t('order-cutoff-times.days-in-advance.2'),
    },
    {
      value: '3',
      label: t('order-cutoff-times.days-in-advance.3'),
    },
    {
      value: '4',
      label: t('order-cutoff-times.days-in-advance.4'),
    },
    {
      value: '5',
      label: t('order-cutoff-times.days-in-advance.5'),
    },
    {
      value: '6',
      label: t('order-cutoff-times.days-in-advance.6'),
    },
    {
      value: '7',
      label: t('order-cutoff-times.days-in-advance.7'),
    },
  ];
  return (
    <Select value={valueProp} onValueChange={onChange}>
      <SelectTrigger className={cn('select-trigger', className)}>
        {ordersDaysDeadlines.find(({ value }) => value === valueProp)?.label}
      </SelectTrigger>
      <SelectContent className="select-content">
        {ordersDaysDeadlines.map(({ value, label }) => (
          <SelectItem key={value} value={value} className="select-item">
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default OrderCutoffDaysSelect;
